<style lang="less">
.receive_msg{width:100%;background:#eee;border-radius:5px;padding:20px;box-sizing:border-box;display:flex;margin-top:20px;
	.msg_txt{flex:1;
		p{color:#666;font-size:15px;}
	}
	.qr_code{width:150px;}
}
.ctrl_btn_box{width:100%;text-align:center;
	.ctrl_btn{width:170px;height:55px;}
}
.avatar-uploader{width: 220px;float:left;margin-right:20px;border-radius: 5px;border: 1px solid #ddd;text-align: center;
	height: 122px;line-height: 122px;overflow: hidden;
	.el-icon-plus{font-size:36px;}
	.el-icon-delete{cursor: pointer;}
	.card_box{position:relative;min-height:100px;width:100%;
		.el-icon-plus,.el-icon-delete{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.3);color: #fff;display: flex;
			justify-content: center;align-items: center;font-size: 36px;opacity:0;}
	}
	.file_box{float:left;}
	&:hover{
		.card_box .el-icon-plus{opacity:1;}
		.card_box .el-icon-delete{opacity:1;}
	}
	img{width:100%;}
}
</style>
<template>
	<el-dialog title="证书及档案领取" :visible.sync="visible" :before-close="close_fn" :close-on-click-modal="false" width="60%">
		<div class="cert_pickup_type">
			<el-radio-group :disabled="cert_pickup_type > 0" v-model="cert_pickup_type_select">
				<el-radio-button label="1">到校领取</el-radio-button>
				<el-radio-button label="2">邮寄领取</el-radio-button>
			</el-radio-group>
		</div>
		<div class="receive_msg" v-if="cert_pickup_type_select == '1'">
			<div class="msg_txt">
				<p>1、领取时间：2026年7月27日—7月31日(9:00-12:00,14:00-17:00)</p>
				<p>2、领取地点：麻章校区二号实验楼二楼继续教育学院办公室</p>
				<p>3、领取要求：须由本人持身份证原件到场领取</p>
				<p>4、右图为入校登录二维码</p>
			</div>
			<img :src="global.oss_link + 'xuexi.qsxueli.com/pc/images/zhanke_Mini_Program_QR_code.jpg'" alt="身份证反面" class="qr_code" />
		</div>
		<div class="post_receive" v-if="cert_pickup_type_select == '2'">
			<div class="receive_msg">
				<div class="msg_txt">
					<p>1、证书及档案采用顺丰到付方式寄送；</p>
					<p>2、收件人保持电话畅通，及时签收并现场查验邮件；</p>
					<p>3、邮寄服务遵循自愿原则，须由本人完成申请，未上传《邮寄委托书》者无法提交。</p>
				</div>
			</div>
			<div class="form_box mt-20">
				<el-form v-loading="loading" autocomplete="off"
				:model="post_receive"
				:rules="rules" ref="form_ref" label-width="100px">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="收件人" prop="real_name">
								<el-input type="text" v-model="post_receive.real_name"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="手机号" prop="mobile">
								<el-input type="text" v-model="post_receive.mobile"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="收件地址" prop="consignee_address">
								<el-input type="text" v-model="post_receive.consignee_address"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-form-item label="身份证" prop="consignee_address">
							<p>要求：包含正面、反面，上传文件为jpg格式，文件大小在5M以内</p>
							<el-upload
								class="avatar-uploader"
								ref="upload"
								:action="global.oss_link"
								:show-file-list="false"
								:before-upload="beforeAvatarUpload"
								:http-request="http_request_zheng">
								<div slot="tip" v-if="post_receive.attachments[0].url" class="card_box file_box">
									<i class="el-icon-delete" v-if="cert_pickup_type == 0" @click="handleRemove(0)"></i>
									<img :src="global.oss_link + post_receive.attachments[0].url" class="img">
								</div>
								<div v-else class="card_box default_box">
									<i class="el-icon-plus"></i>
									<img :src="yang_ben_zheng" class="img">
								</div>
							</el-upload>
							<el-upload
								class="avatar-uploader"
								ref="upload"
								:action="global.oss_link"
								:show-file-list="false"
								:before-upload="beforeAvatarUpload"
								:http-request="http_request_fan">
								<div slot="tip" v-if="post_receive.attachments[1].url" class="card_box file_box">
									<i class="el-icon-delete" v-if="cert_pickup_type == 0" @click="handleRemove(1)"></i>
									<img :src="global.oss_link + post_receive.attachments[1].url" class="img">
								</div>
								<div v-else class="card_box default_box">
									<i class="el-icon-plus"></i>
									<img :src="yang_ben_fan" class="img">
								</div>
							</el-upload>
						</el-form-item>
					</el-row>
					<el-row :gutter="20">
						<el-form-item label="邮寄委托书" prop="consignee_address">
							<p>
								要求：上传文件为jpg格式，文件大小在5M以内
								<el-button size="small" type="primary" @click="download_commissionBook">模板下载</el-button>
							</p>
							<el-upload
								class="avatar-uploader"
								ref="upload"
								:action="global.oss_link"
								:show-file-list="false"
								:before-upload="beforeAvatarUpload"
								:http-request="http_request_commission_book">
								<div slot="tip" v-if="post_receive.attachments[2].url" class="card_box file_box">
									<i class="el-icon-delete" v-if="cert_pickup_type == 0" @click="handleRemove(2)"></i>
									<img :src="global.oss_link + post_receive.attachments[2].url" class="img">
								</div>
								<div v-else class="default_box">
									<i class="el-icon-plus"></i>
								</div>
							</el-upload>
						</el-form-item>
					</el-row>
				</el-form>
			</div>
		</div>
		<div class="ctrl_btn_box mt-20" v-if="cert_pickup_type_select > 0">
			<el-button class="ctrl_btn" type="primary" v-if="cert_pickup_type == 0" @click="save_data()">确认提交</el-button>
			<el-popconfirm v-else
				confirm-button-text='确定'
				cancel-button-text='不用了'
				icon="el-icon-info"
				icon-color="red"
				title="确定撤回提交吗？"
				@confirm="cancel"
			>
				<el-button slot="reference" class="ctrl_btn" type="danger">撤回提交</el-button>
			</el-popconfirm>
		</div>
	</el-dialog>
</template>
    
<script>
export default {
	props: {
		cert_pickup_type: {
			type: Number,
			default: 0
		},
		mailing_apply: {
			type: Object,
			default: {}
		},
		my_id: {
			type: Number,
			default: 0
		},
	}
	,components:{
	}
	,data () {
		const yang_ben_zheng = 'https://oss.test5184.com/520.test5184.com/entryForm/images/yangbenzheng.png'
		const yang_ben_fan = 'https://oss.test5184.com/520.test5184.com/entryForm/images/yangbenfan.png'
		return {
			yang_ben_zheng,
			yang_ben_fan,
			cert_pickup_type_select: '1',
			visible: true,
		    serverSrc: this.global.serverSrc,
		    qianzui: this.global.qianzui,
			school_receive:{
				tpl_id: 4,
				cert_pickup_type: 1
			},
			post_receive: {
				id: 0,
				tpl_id: 4,
				cert_pickup_type:2,
				real_name: "",
				mobile: '',
				consignee_address: "",
				attachments: [
					{
						title: "身份证正面",
						url: "",
						code: "id_card_front"
					},
					{
						title: "身份证背面",
						url: "",
						code: "id_card_back"
					},
					{
						title: "邮寄委托书",
						url: "",
						code: "entrust"
					}
				]
			},
			rules: {
				consignee_address: [
					{ required: true, message: '请输入收件地址', trigger: 'blur' }
				],
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' }
				],
				real_name: [
					{ required: true, message: '请输入收件人', trigger: 'blur' }
				],
			},
			file_list:[],
			
			loading: false,
			my_mailing_id: 0,
			my_mailing_list: [],
			enroll_btn_txt: '编辑',
			form_visible: false,
			mail_application_close_time: '',
			paper_mail_btn_visible: false,
		}
	}
	,mounted:function(){
		this.init()
	}
	,methods:{
		// 下载模板
		download_commissionBook() {
			window.open(this.global.oss_link+'xuexi.qsxueli.com/pc/file/zhanke_commissionBook.docx')
		},
		// 覆盖默认的上传行为，可以自定义上传的实现	function
		http_request_zheng(file){
			this.request(file, 'id_card_front')
		},
		// 覆盖默认的上传行为，可以自定义上传的实现	function
		http_request_fan(file){
			this.request(file, 'id_card_back')
		},
		// 覆盖默认的上传行为，可以自定义上传的实现	function
		http_request_commission_book(file){
			this.request(file, 'entrust')
		},
		request(file, self_name){
			this.$selfjs.ossUpload(this, {
				file: file.file,
				self_name,
				path: `/graduate_certificate/my_id_${this.my_id}/`,
				success: (res)=>{
					// 保存路径
					this.post_receive.attachments.find(f=>{ return f.code == self_name }).url = res.upload_path
				},
				complete: ()=>{

				},
			})
		},
		// 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。	function(file)
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg';
			const isLt10M = file.size / 1024 / 1024 < 5;

			if (!isJPG) {
				this.$message.error('上传文件只能是 JPG 格式!');
			}
			if (!isLt10M) {
				this.$message.error('上传文件大小不能超过 5MB!');
			}
			return isJPG && isLt10M;
		},
		handleRemove(idx) {
			let link = this.post_receive.attachments[idx].url
			this.$selfjs.delOssFile(this, [this.global.oss_link+link])
			this.post_receive.attachments[idx].url = ''
		},
		// 提交
		save_data(){
			let post_data
			switch(this.cert_pickup_type_select){
				case "1":
					post_data = this.school_receive
					break;
				case "2":
					post_data = this.post_receive
					break;
			}
			this.$ajax.post(this.serverSrc + this.qianzui + "/enroll_advice_note/save",
				this.$qs.stringify(post_data)
			)
			.then(res=>{
				let resData = res.data;
				if(resData.code == 0){
					this.$message.success('提交成功！');
					this.close_fn()
				}
			})
		},
		// 撤回提交（在申请时间内已提交学生可撤回提交）
		cancel(){
			this.$ajax.post(this.serverSrc + this.qianzui + "/enroll_advice_note/cancel",
				this.$qs.stringify({
					apply_id: this.post_receive.id,
				})
			)
			.then(res=>{
				let resData = res.data;
				if(resData.code == 0){
					this.$message.success('撤回提交成功！');
					this.close_fn()
				}
			})
		},
		init(){
			this.my_mailing_apply()
		},
		my_mailing_apply(){
			if(this.cert_pickup_type > 0) this.cert_pickup_type_select = this.cert_pickup_type
			let detail = this.mailing_apply.detail
			// 判断是否有提交过申请
			if(detail){
				this.post_receive.id = detail.id
				this.post_receive.tpl_id = this.school_receive.tpl_id = this.mailing_apply.tpl.id
				if(detail.attachments) this.post_receive = detail
			}
		},
		close_fn(done){
			this.visible = false
			this.$emit("ruleFormInfon")
			this.$emit("myMailingApply")
			this.$emit("close_open")
		}
	}
	,computed:{
	}
	,watch: {
	}
}
</script>


// WEBPACK FOOTER //
// src/components/userCenter/graduate_certificate.vue